import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { Modal } from '../../components/Modal'
import { SchoolListingForm } from '../SchoolListingForm/SchoolListingForm'
import { createChangeRequest } from '../../states/schools/changeRequests/actions'
import { CHANGE_REQUEST_TYPE } from '@laputan/core'
import { showModal } from '../../states/modals/actions'
import { ModalType } from '../../states/modals/ModalType.constants'

interface ICreateChangeRequestModalProps {
  header: string
  type: string
  otherRequestParams?: object
}

const CreateChangeRequestModal: React.FC<ICreateChangeRequestModalProps> = ({
  header,
  type,
  otherRequestParams,
}) => {
  const dispatch = useDispatch()
  const [formFields, setFormFields] = useState({})
  const [isCreating, setIsCreating] = useState(false)
  let form
  switch (type) {
    case CHANGE_REQUEST_TYPE.NEW_LISTING:
    case CHANGE_REQUEST_TYPE.UPDATE_LISTING: {
      form = (
        <SchoolListingForm
          formFields={formFields}
          isSubmitting={isCreating}
          onChange={(ff) => setFormFields(ff)}
          onSubmit={() => {
            setIsCreating(true)
            dispatch(
              createChangeRequest({
                type,
                contact: formFields.contact,
                data: Object.assign(formFields.data, otherRequestParams),
                success: (data) => {
                  console.log('data', data)
                  setIsCreating(false)
                  setFormFields({})
                  dispatch(
                    showModal(ModalType.CHANGE_REQUEST_SUBMITTED, {
                      id: data.changeRequest.id,
                    })
                  )
                },
                fail: () => setIsCreating(false),
              })
            )
          }}
        />
      )
      break
    }
    case CHANGE_REQUEST_TYPE.NEW_SCHOOL:
    case CHANGE_REQUEST_TYPE.UPDATE_SCHOOL: {
      return null
    }
    default:
      return null
  }
  return (
    <Modal header={header} onCloseClick={() => setFormFields({})}>
      {form}
    </Modal>
  )
}

export { CreateChangeRequestModal }
